import React, {createContext, useContext, useReducer, useEffect ,useRef} from "react";
import { useAuthService } from "./AuthServiceProvider";
import { useSessionStorage } from "../common/components/useSessionStorage";

// Define the initial state for the Auth Context
const initialAuthState = {
  user: {
      email:'',
      password:'',
  },
  token: '',
  role:''
}

export const AuthContext = createContext();

const SET_AUTH = 'SET_AUTH'
const SET_ROLE = 'SET_ROLE'
const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN'
const SET_LOGOUT = 'SET_LOGOUT'

// Define the reducer function for the Auth Context
const authReducer = (state, action) => {
  switch (action.type) {
      case SET_AUTH:
          return {...state, user: action.payload};
      case SET_AUTH_TOKEN:
          return {...state , token: action.payload};
      case SET_ROLE:
          return {...state, role: action.payload}
      case SET_LOGOUT:
          return initialAuthState
      default:
          throw new Error('Invalid action type')
  }
}

export const AuthContextProvider = ({ children }) => {

  const [state, dispatch] = useReducer(authReducer, initialAuthState);

  // // Use useSessionStorage hook to manage state with session storage
  // const [storedAuthState, setStoredAuthState] = useSessionStorage(
  //   "authState",
  //   initialAuthState
  // );
  // const isInitialMount = useRef(true); // useRef to track the initial mount

  // useEffect(() => {
  //   // Load the persisted state from session storage when the component mounts
  //   if (isInitialMount.current) {
  //     dispatch({ type: SET_AUTH, payload: storedAuthState });
  //     isInitialMount.current = false;
  //   }
  // }, [storedAuthState]);

  // useEffect(() => {
  //   // Save the authentication state in session storage whenever it changes
  //   setStoredAuthState(state);
  // }, [state, setStoredAuthState]);


  const handlers = {
    setAuth: (auth) => {
      return new Promise(resolve=>resolve(dispatch( {type: SET_AUTH, payload:auth} )))
    },
    setAuthToken: (token) => {
      return new Promise(resolve=>resolve(dispatch( {type: SET_AUTH_TOKEN, payload:token} )))
    },
    setRole: (role) => {
      return new Promise(resolve=>resolve(dispatch( {type: SET_ROLE, payload:role} )))
    },
    clearAuthToken: () => {        
      return new Promise(resolve=>resolve(dispatch( {type: SET_AUTH_TOKEN, payload:{} } )))
    },
  }

  return(
    <AuthContext.Provider value={{state,handlers}}>
        {children}
    </AuthContext.Provider>
  )
}



export const useAuth = () => {
  const [ state, handlers ] = useAuthService(useContext(AuthContext))
  return [ state, handlers ]
}